import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
//import $ from "jquery";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import Carousel from "react-bootstrap/Carousel";
import Footer from "./includes/Footer";
import Register from "./includes/Register";
import { history } from "../helper/History";
import $ from "jquery";
import { bindActionCreators } from "redux";
import CookieConsent from "react-cookie-consent";

// PRH SAFE ADDITION START: FT individual free test completed notice imports
import axios from "axios";
import { ROOT_URL } from "../helper/Config";
// PRH SAFE ADDITION END

//import { FormattedMessage } from "react-intl";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dis: "",
      display: "null",

      // PRH SAFE ADDITION START: FT individual free test completed notice state
      remainingTest: null,
      // PRH SAFE ADDITION END
    };
    window.scrollTo(0, 0); // scroll page to top
  }

  setContactus() {
    // localStorage.setItem("redirectpage","Consultant")
    localStorage.removeItem("contactus")

    localStorage.setItem("contactus", "1");
  }

  setNavigationValue(value) {
    localStorage.setItem("navigation", value);
  }

  // PRH SAFE ADDITION START: FT individual free test completed notice status
  loadFtIndividualFreeTestStatus() {
    const userRole = localStorage.getItem("userRole");
    const userId =
      localStorage.getItem("userId") ||
      localStorage.getItem("userid") ||
      localStorage.getItem("user_id") ||
      localStorage.getItem("id");

    if (userRole !== "User" || !userId) {
      return;
    }

    axios
      .get(`${ROOT_URL}/getTests/${userId}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then((response) => {
        this.setState({
          remainingTest: response.data.tests,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  // PRH SAFE ADDITION END

  componentDidMount() {

    // if (typeof this.props.location.state === "object") {
    //   // check if type is object
    //   if (this.props.location.state.from === "home") {
    //     // check if state.from is home open happiness modal
    //     $("#happiness").modal(); // show model if it comes from home
    //   }
    // }

    // PRH SAFE ADDITION START: FT individual free test completed notice status call
    this.loadFtIndividualFreeTestStatus();
    // PRH SAFE ADDITION END

  }

  banner() {
    return (
      <div className="alert-block">
        <div
          class="alert alert-dark alert-dismissible fade show "
          style={{ color: "white", backgroundColor: "black" }}
          role="alert"
        >
          <FormattedHTMLMessage id="banner" defaultMessage="FAQ" />
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    );
  }

  showRegister(e) {
    var userType = localStorage.getItem("role");
    if (!userType) {
      history.push("/register");
      // console.log('in '+e);
      // $("#loginModal").modal("show");
      // $("#register-form").delay(100).fadeIn(100);
      // $("#login-form").fadeOut(100);
      // $("#login-form-link").removeClass("active");
      // console.log('Inside Header '+e);
      // if(e === '#register-form-link'){
      //   $('.modal-title').text('SIGNUP');
      //   $(e).addClass("active");
      // }else{
      //   $(e.target).addClass("active");
      // }
    }
  }
  showRegister2(e) {
    //  console.log("in " + e);
    $("#loginModal").modal("show");
    $("#register-form").delay(100).fadeIn(100);
    $("#login-form").fadeOut(100);
    $("#login-form-link").removeClass("active");
    // console.log("Inside Header " + e);
    if (e === "#register-form-link") {
      $(".modal-title").text("SIGNUP");
      $(e).addClass("active");
    } else {
      $(e.target).addClass("active");
    }
  }

  render() {
    return (
      <React.Fragment>


        <section className="prh-home-v2-wrapper">
          <div className="prh-home-v2-hero-bg">

            {/* Top Row */}
            <div className="prh-home-v2-top-row">
              {/* Partner Card */}
              <div className="prh-home-v2-partner-card">
                <div className="prh-home-v2-partner-title">
                  <FormattedHTMLMessage id="home.partner" defaultMessage="Partenaire" />
                </div>
                <div className="prh-home-v2-partner-img">
                  <img src="assets/images/trav.png" alt="Trav Logo" />
                </div>
              </div>

              {/* Center Career Path */}
              <div className="prh-home-v2-center-card">
                <div className="prh-home-v2-logo-overlap">
                  <img src="assets/images/logo.png" alt="Pilot RH Logo" />
                  <div className="d-none">
                    <FormattedHTMLMessage id="home.logo.rep.text" defaultMessage="Are you a Skills Assessment Consultant?" />
                  </div>
                </div>
                <div className="prh-home-v2-platform-box">
                  <h3>
                    <b><FormattedHTMLMessage id="homepageslider" defaultMessage="LA PLATEFORME 360°" /></b>
                  </h3>
                  <h4>
                    <FormattedHTMLMessage id="homepageslider2" defaultMessage="LA PLATEFORME 360°" />
                  </h4>

                </div>
                <h4 className="homeslider-v2-center-card">
                  <FormattedHTMLMessage id="homepageslider3" defaultMessage="fast, readable,<br> economical" />
                </h4>
              </div>

              {/* Right Side Cards */}
              <div className="prh-home-v2-right-stack">
                <div className="prh-home-v2-contact-card">
                  <div className="prh-home-v2-card-content">
                    <div className="prh-home-v2-icon">
                      <img src="assets/images/contact_icon.png" alt="Contact" onError={(e) => { e.target.style.display = 'none'; }} />
                    </div>
                    <p className="prh-home-v2-title">
                      <FormattedHTMLMessage id="home-register-text" defaultMessage="Vous souhaitez travailler avec nous ?" />
                    </p>
                    <p className="prh-home-v2-subtext">
                      <FormattedHTMLMessage id="home-register-text2" defaultMessage="Contactez-nous au 09 83 20 00 15..." />
                    </p>
                  </div>
                  <div className="prh-home-v2-action">
                    <a href="/contact-us">
                      <button>
                        <FormattedHTMLMessage id="contact_signal" defaultMessage="CONTACT" />
                      </button>
                    </a>
                  </div>
                </div>

                <div className="prh-home-v2-meeting-card">
                  <div className="prh-home-v2-card-content">
                    <p className="prh-home-v2-title">
                      <FormattedHTMLMessage id="home.titlebtn" defaultMessage="PRISE RDV PILOTRH" />
                    </p>
                    <div className="prh-home-v2-avatar">
                      <img src="assets/images/AGENDA_IMAGE.jpg" alt="Agenda" />
                    </div>
                  </div>
                  <div className="prh-home-v2-action">
                    <a href="https://calendly.com/plateforme-pilotrh-evaluation-des-talents">
                      <button>
                        <FormattedHTMLMessage id="demo_metting" defaultMessage="RDV DEMO" />
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* PRH SAFE ADDITION START: FT individual free test completed homepage notice */}
            {localStorage.getItem("userRole") === "User" &&
              String(this.state.remainingTest) === "0" && (
                <div
                  className="prh-ft-individual-notice-wrapper"
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "8px",
                    marginBottom: "22px",
                    position: "relative",
                    zIndex: 5,
                  }}
                >
                  <div
                    className="prh-ft-individual-notice"
                    role="alert"
                    style={{
                      maxWidth: "720px",
                      width: "100%",
                      backgroundColor: "#e9f6df",
                      color: "#111111",
                      textAlign: "center",
                      padding: "12px 22px",
                      fontSize: "14px",
                      lineHeight: "1.6",
                      borderRadius: "0",
                      boxShadow: "none",
                    }}
                  >
                    <div>
                      Vous avez déjà réalisé un premier test gratuit, vous pouvez continuer sur notre site dans la rubrique Particulier (tests payants).
                    </div>
                    <div
                      style={{
                        marginTop: "12px",
                        fontSize: "12px",
                        lineHeight: "1.45",
                      }}
                    >
                      You have already completed an initial free test; you can continue on our site in the "Individuals" section (paid tests).
                    </div>
                  </div>
                </div>
              )}
            {/* PRH SAFE ADDITION END */}

            {/* Service Cards */}
            <ul className="prh-home-v2-service-row">
              <li className="prh-home-v2-service-card">
                <Link to="/youareaconsultant"  onClick={() => this.setNavigationValue("skills")}>
                  <div className="prh-home-v2-service-icon">
                    <span className="prh-home-v2-icon-symbol">👥</span>
                  </div>
                  <div className="prh-home-v2-service-top">
                    <span><FormattedHTMLMessage id="home.hero.text" /></span>
                  </div>
                  <div className="prh-home-v2-service-bottom">
                    <span><FormattedHTMLMessage id="home.hero.text.sub" /> &rarr;</span>
                  </div>
                </Link>
              </li>

              <li className="prh-home-v2-service-card">
                <Link to="/youareacompany"  onClick={() => this.setNavigationValue("enterprise")}>
                  <div className="prh-home-v2-service-icon">
                    {/* <span className="prh-home-v2-icon-symbol">🧑‍🤝‍🧑</span>
                     */}
                    <svg className="prh-home-v2-svg-icon" viewBox="0 0 64 64" aria-hidden="true">
                      {/* back row */}
                      <circle cx="14" cy="18" r="8" fill="currentColor" />
                      <circle cx="32" cy="15" r="9" fill="currentColor" />
                      <circle cx="50" cy="18" r="8" fill="currentColor" />

                      {/* middle row */}
                      <circle cx="23" cy="29" r="8" fill="currentColor" />
                      <circle cx="41" cy="29" r="8" fill="currentColor" />

                      {/* front center */}
                      <circle cx="32" cy="35" r="8" fill="currentColor" />

                      {/* bodies */}
                      <path d="M4 50c1-10 6-17 14-17s13 7 14 17H4z" fill="currentColor" />
                      <path d="M32 50c1-10 6-17 14-17s13 7 14 17H32z" fill="currentColor" />
                      <path d="M14 55c1-11 7-18 16-18s15 7 16 18H14z" fill="currentColor" />
                      <path d="M22 60c1-11 5-18 10-18s9 7 10 18H22z" fill="currentColor" />
                    </svg>
                  </div>
                  <div className="prh-home-v2-service-top">
                    <span><FormattedHTMLMessage id="home.hero.text1" /></span>
                  </div>
                  <div className="prh-home-v2-service-bottom">
                    <span><FormattedHTMLMessage id="home.hero.text.sub1" /> &rarr;</span>
                  </div>  
                </Link>
              </li>

              <li className="prh-home-v2-service-card">
                <Link to="/individual" onClick={() => this.setNavigationValue("individual")}>
                  <div className="prh-home-v2-service-icon">
                    <span className="prh-home-v2-icon-symbol">📚</span>
                  </div>
                  <div className="prh-home-v2-service-top">
                    <span><FormattedHTMLMessage id="home.hero.text2" /></span>
                  </div>
                  <div className="prh-home-v2-service-bottom">
                    <span><FormattedHTMLMessage id="home.hero.text.sub2" /> &rarr;</span>
                  </div>
                </Link>
              </li>
            </ul>

            {/* Testimonials */}
            <div className="prh-home-v2-testimonial-row">
              <div className="prh-home-v2-testimonial-card">
                <h5 className="prh-home-v2-testimonial-heading">
                  <FormattedHTMLMessage id="aboutus.menutitle5" defaultMessage="Testimonials" />
                </h5>
                <div className="prh-home-v2-testimonial-carousel">
                  <Carousel indicators={false} interval={4000}>
                    <Carousel.Item>
                      <div className="prh-home-v2-testimonial-slide">
                        <div className="prh-home-v2-testimonial-text">
                          <FormattedHTMLMessage id="testimonial.desc1" defaultMessage="Testimonials" />
                        </div>
                        <div className="prh-home-v2-author-divider"></div>
                        <div className="prh-home-v2-author-name"><FormattedHTMLMessage id="testimonial.desc1_author" defaultMessage="Testimonials" /></div>
                        {/* <div className="prh-home-v2-author-role">Formatrice Coach Certifiée RNCP</div> */}
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="prh-home-v2-testimonial-slide">
                        <div className="prh-home-v2-testimonial-text">
                          <FormattedHTMLMessage id="testimonial.desc2" defaultMessage="Testimonials" />
                        </div>
                        <div className="prh-home-v2-author-divider"></div>
                        <div className="prh-home-v2-author-name"><FormattedHTMLMessage id="testimonial.desc2_author" defaultMessage="Testimonials" /></div>
                        {/* <div className="prh-home-v2-author-role">Formatrice Coach Certifiée RNCP</div> */}
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="prh-home-v2-testimonial-slide">
                        <div className="prh-home-v2-testimonial-text">
                          <FormattedHTMLMessage id="testimonial.desc3" defaultMessage="Testimonials" />
                        </div>
                        <div className="prh-home-v2-author-divider"></div>
                        <div className="prh-home-v2-author-name"><FormattedHTMLMessage id="testimonial.desc3_author" defaultMessage="Testimonials" /></div>
                        {/* <div className="prh-home-v2-author-role">Formatrice Coach Certifiée RNCP</div> */}
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="prh-home-v2-testimonial-slide">
                        <div className="prh-home-v2-testimonial-text">
                          <FormattedHTMLMessage id="testimonial.desc1" defaultMessage="Testimonials" />
                        </div>
                        <div className="prh-home-v2-author-divider"></div>
                        <div className="prh-home-v2-author-name"><FormattedHTMLMessage id="testimonial.desc1_author" defaultMessage="Testimonials" /></div>
                        {/* <div className="prh-home-v2-author-role">Formatrice Coach Certifiée RNCP</div> */}
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="prh-home-v2-testimonial-slide">
                        <div className="prh-home-v2-testimonial-text">
                          <FormattedHTMLMessage id="testimonial.desc4" defaultMessage="Testimonials" />
                        </div>
                        <div className="prh-home-v2-author-divider"></div>
                        <div className="prh-home-v2-author-name"><FormattedHTMLMessage id="testimonial.desc4_author" defaultMessage="Testimonials" /></div>
                        {/* <div className="prh-home-v2-author-role">Formatrice Coach Certifiée RNCP</div> */}
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="prh-home-v2-testimonial-slide">
                        <div className="prh-home-v2-testimonial-text">
                          <FormattedHTMLMessage id="testimonial.desc5" defaultMessage="Testimonials" />
                        </div>
                        <div className="prh-home-v2-author-divider"></div>
                        <div className="prh-home-v2-author-name"><FormattedHTMLMessage id="testimonial.desc5_author" defaultMessage="Testimonials" /></div>
                        {/* <div className="prh-home-v2-author-role">Formatrice Coach Certifiée RNCP</div> */}
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="prh-home-v2-testimonial-slide">
                        <div className="prh-home-v2-testimonial-text">
                          <FormattedHTMLMessage id="testimonial.desc12" defaultMessage="Testimonials" />
                        </div>
                        <div className="prh-home-v2-author-divider"></div>
                        <div className="prh-home-v2-author-name"><FormattedHTMLMessage id="testimonial.desc12_author" defaultMessage="Testimonials" /></div>
                        {/* <div className="prh-home-v2-author-role">Formatrice Coach Certifiée RNCP</div> */}
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="prh-home-v2-testimonial-slide">
                        <div className="prh-home-v2-testimonial-text">
                          <FormattedHTMLMessage id="testimonial.desc13" defaultMessage="Testimonials" />
                        </div>
                        <div className="prh-home-v2-author-divider"></div>
                        <div className="prh-home-v2-author-name"><FormattedHTMLMessage id="testimonial.desc13_author" defaultMessage="Testimonials" /></div>
                        {/* <div className="prh-home-v2-author-role">Formatrice Coach Certifiée RNCP</div> */}
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="prh-home-v2-testimonial-slide">
                        <div className="prh-home-v2-testimonial-text">
                          <FormattedHTMLMessage id="testimonial.desc14" defaultMessage="Testimonials" />
                        </div>
                        <div className="prh-home-v2-author-divider"></div>
                        <div className="prh-home-v2-author-name"><FormattedHTMLMessage id="testimonial.desc14_author" defaultMessage="Testimonials" /></div>
                        {/* <div className="prh-home-v2-author-role">Formatrice Coach Certifiée RNCP</div> */}
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="prh-home-v2-testimonial-slide">
                        <div className="prh-home-v2-testimonial-text">
                          <FormattedHTMLMessage id="testimonial.desc15" defaultMessage="Testimonials" />
                        </div>
                        <div className="prh-home-v2-author-divider"></div>
                        <div className="prh-home-v2-author-name"><FormattedHTMLMessage id="testimonial.desc15_author" defaultMessage="Testimonials" /></div>
                        {/* <div className="prh-home-v2-author-role">Formatrice Coach Certifiée RNCP</div> */}
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="prh-home-v2-testimonial-slide">
                        <div className="prh-home-v2-testimonial-text">
                          <FormattedHTMLMessage id="testimonial.desc16" defaultMessage="Testimonials" />
                        </div>
                        <div className="prh-home-v2-author-divider"></div>
                        <div className="prh-home-v2-author-name"><FormattedHTMLMessage id="testimonial.desc16_author" defaultMessage="Testimonials" /></div>
                        {/* <div className="prh-home-v2-author-role">Formatrice Coach Certifiée RNCP</div> */}
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="prh-home-v2-testimonial-slide">
                        <div className="prh-home-v2-testimonial-text">
                          <FormattedHTMLMessage id="testimonial.desc17" defaultMessage="Testimonials" />
                        </div>
                        <div className="prh-home-v2-author-divider"></div>
                        <div className="prh-home-v2-author-name"><FormattedHTMLMessage id="testimonial.desc17_author" defaultMessage="Testimonials" /></div>
                        {/* <div className="prh-home-v2-author-role">Formatrice Coach Certifiée RNCP</div> */}
                      </div>
                    </Carousel.Item>
                  </Carousel>
                </div>
              </div>
            </div>

            {/* Dark Banner */}
            {/* <div className="prh-home-v2-dark-banner">
              <FormattedHTMLMessage id="home.textnote" defaultMessage="TAKE STOCK OF YOUR CAREER WITH OR WITHOUT A COACH" />
            </div> */}

          </div>
        </section>





        <Footer />
      </React.Fragment>
    );
  }
}

export default Home;